import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { getPopupIdByTemplateId, LAYER } from 'js/components/common/PopupManager';

// todo handle different types of messages according to API ShowMessageNotification (31026)
export const handleShowMessageNotification = ({ message, closeClient, templateId, className, title }) => showCommonPopupAction({
    content: message,
    ...className && { className },
    id: getPopupIdByTemplateId(templateId),
    title: title || 'playtech.mobile.system.message.congratulations',
    ...closeClient && { layer: LAYER.LOGOUT_MESSAGES }
});
